const axios             = require('axios');
import JsLoading from "./JsLoading";
require("fslightbox");
// import Simplelightbox from './SimpleLightBox';

const PaginationAjax = function() {

    const seeMore = (e) => {
        e.preventDefault();

        let el                  = $(e.currentTarget);
        let nextPage            = parseInt(el.attr('data-page'));
        let categoryPage        = parseInt(el.attr('data-category'));
        let urlAjax             = el.attr('data-url');
        let totalShowForPage    = parseInt(el.attr('data-totalpage'));
        const lastElmList       = $("#ajax-list-dinamic");

        const _parent           = el.closest('.parentAjaxGalCategory');
        const urlGal            = el.attr('data-url'); 
        const titleImgAjax      = _parent.find('.js-dinamic-title');
        const textImgAjax       = _parent.find('.js-dinamic-text');
        const linkImgAjax       = _parent.find('.js-dinamic-link');

        el.addClass('bt-loading');

        el.prop('disabled', true);
        el.fadeOut(100);

        nextPage = nextPage + 1;

        JsLoading.showLoading(el);

        //detect controller
        let pagController = '';
        switch (categoryPage) {
            case 4:
                pagController = 'edicoes-anteriores';
                break;

            default:
                pagController = 'news';
                break;
        }

        axios.get(urlAjax, {
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            params : {
                page : nextPage
            }
        })
        .then(function (response) {

            const data = response.data;

            // console.log(data);

            titleImgAjax.text(data.title);   
            textImgAjax.html(data.content);   
            linkImgAjax.attr('href', data.link);   
            totalShowForPage = data.total_pages;
            _parent.find('.ajaxImageCategory').append(data.files);

            el.removeClass('bt-loading');

            urlAjax = urlAjax.split(pagController+'/')[0]+pagController+'/'+categoryPage+'/'+nextPage+'/'+totalShowForPage;
            // lastElmList.append(response.data);
            el.attr('data-page', nextPage);
            // el.attr('data-url', urlAjax);
            // window.history.pushState({ url: window.location.href }, null, urlAjax.split(pagController+'/')[0]+pagController+'/'+categoryPage+'/'+(nextPage -1)+'/'+totalShowForPage);
           
        })
        .catch(function (error) {
                // handle error
            console.log(error);
        })
        .finally(function () {
            JsLoading.hideLoading(el);
            el.prop('disabled', false);
            el.fadeIn(100);

             // oculta ou não o botão "more"
            //  console.log( parseInt(nextPage) , parseInt(totalShowForPage) );
            if( parseInt(nextPage) >= parseInt(totalShowForPage)){
                el.fadeOut(300);
            } else {
                el.fadeIn(100);                
            }

            // Simplelightbox.constlightBx();
            refreshFsLightbox();

            /* if( lastElmList.find('>div').length < totalShowForPage * (nextPage -1) ) {
                $('.act-link.ajax-more').fadeOut(300);
            } */

        });
    }
    return {
        init : function(status){
            // click ver mais
            $(document).on('click', '.ajax-more', seeMore);
        }
    }

}();

export default PaginationAjax;
